var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 157.141,
    height: 161.249,
    viewBox: "0 0 157.141 161.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#141420;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-145.509 -271.188)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.1,299.744a2.138,2.138,0,0,1-2.155-2.14V291.6a2.144,2.144,0,1,0-4.288,0V297.6a6.447,6.447,0,0,0,6.443,6.45h.1a2.119,2.119,0,0,0,2.1-2.147A2.215,2.215,0,0,0,154.1,299.744Z",
    transform: "translate(13.502 114.689)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.807,303a2.147,2.147,0,0,0,2.14-2.155V288.086a2.144,2.144,0,0,0-4.288,0v12.755A2.148,2.148,0,0,0,149.807,303Z",
    transform: "translate(13.502 92.683)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M149.807,299.507a2.152,2.152,0,0,0,2.14-2.177V284.575a2.144,2.144,0,0,0-4.288,0V297.33A2.153,2.153,0,0,0,149.807,299.507Z",
    transform: "translate(13.502 70.677)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M162.781,283.682h12.755a2.144,2.144,0,1,0,0-4.288H162.781a2.144,2.144,0,1,0,0,4.288Z",
    transform: "translate(94.981 51.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M159.277,283.682h12.769a2.144,2.144,0,0,0,0-4.288H159.277a2.144,2.144,0,1,0,0,4.288Z",
    transform: "translate(72.975 51.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M168.525,279.394H155.778a2.144,2.144,0,1,0,0,4.288h12.747a2.144,2.144,0,1,0,0-4.288Z",
    transform: "translate(50.957 51.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M162.67,295.174h12.762a2.155,2.155,0,0,0,0-4.31H162.67a2.155,2.155,0,0,0,0,4.31Z",
    transform: "translate(94.334 123.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M157.023,293.026a2.161,2.161,0,0,0,2.169,2.147H171.94a2.155,2.155,0,0,0,0-4.31H159.192A2.169,2.169,0,0,0,157.023,293.026Z",
    transform: "translate(72.309 123.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M154.961,279.394H154.1a6.447,6.447,0,0,0-6.443,6.428v5.154a2.144,2.144,0,0,0,4.288,0v-5.154a2.147,2.147,0,0,1,2.155-2.14h.859a2.144,2.144,0,1,0,0-4.288Z",
    transform: "translate(13.502 51.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M168.422,290.864H155.66a2.155,2.155,0,0,0,0,4.31h12.762a2.155,2.155,0,1,0,0-4.31Z",
    transform: "translate(50.31 123.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M164.911,290.864h-12.74a2.155,2.155,0,1,0,0,4.31h12.74a2.155,2.155,0,1,0,0-4.31Z",
    transform: "translate(28.305 123.569)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M165.03,279.394H152.268a2.144,2.144,0,1,0,0,4.288H165.03a2.144,2.144,0,1,0,0-4.288Z",
    transform: "translate(28.958 51.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M298.348,354.394h-6.436v-15.7a21.487,21.487,0,0,0-21.447-21.454H256.713a34.619,34.619,0,0,1,13.432-8.2,2.233,2.233,0,0,0,1.42-1.551,2.173,2.173,0,0,0-.582-2.024l-33.634-33.649a2.115,2.115,0,0,0-2.184-.5c-16.14,5.343-23.719,19.067-31.064,32.353-2.614,4.746-5.176,9.355-8.052,13.577H166.956a21.468,21.468,0,0,0-21.447,21.454v72.3a21.462,21.462,0,0,0,21.447,21.447H270.465a21.48,21.48,0,0,0,21.447-21.447V395.257h6.436a4.282,4.282,0,0,0,4.3-4.273V358.7A4.3,4.3,0,0,0,298.348,354.394ZM265.6,306.155a40.879,40.879,0,0,0-14.779,11.08H239.51c5.016-7.564,10.986-13.891,19.969-17.217Zm-9.471-9.471c-7.957,3.407-13.657,9.064-18.382,15.55a18.934,18.934,0,0,0-4.368-7.266,14.814,14.814,0,0,0-7.382-4.15c4.783-6.8,10.469-12.464,18.746-15.528Zm-21.578,20.552H211.416a22.18,22.18,0,0,1,2.111-5.875c2.228-4.179,5.729-6.567,9.61-6.567a10.106,10.106,0,0,1,7.215,3.2A16.151,16.151,0,0,1,234.552,317.236Zm-26.7-11.488c7.069-12.777,13.723-24.862,27.424-29.943l6.21,6.217c-9.231,3.975-15.47,10.869-20.588,18.659-4.565.786-8.605,3.895-11.161,8.67a28.418,28.418,0,0,0-2.73,7.885h-5.977C203.444,313.5,205.708,309.643,207.849,305.748Zm75.487,105.241a12.882,12.882,0,0,1-12.871,12.857H166.956a12.885,12.885,0,0,1-12.886-12.857v-72.3a12.894,12.894,0,0,1,12.886-12.878H270.465a12.891,12.891,0,0,1,12.871,12.878v15.7H240.595a4.3,4.3,0,0,0-4.3,4.3v32.287a4.285,4.285,0,0,0,4.3,4.273h42.741ZM294.06,386.7H244.883V362.984H294.06Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M168.391,301.608a8.689,8.689,0,1,0-8.685-8.678A8.67,8.67,0,0,0,168.391,301.608Zm0-13.09a4.4,4.4,0,1,1-4.4,4.412A4.406,4.406,0,0,1,168.391,288.518Z",
    transform: "translate(89.159 81.906)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletLogo);
export default __webpack_public_path__ + "static/media/wallet_logo.d2eecda84a54cdedb17e71eb418870a9.svg";
export { ForwardRef as ReactComponent };